






























































































































import Vue from 'vue';
import '@/assets/css/landing.less';
import ResponsiveDataMixin from '@/components/mixins/ResponsiveDataMixin.vue';
import LandingOrderBulkModal from '@/components/elements/modals/LandingOrderBulkModal.vue';
import LandingOrderModal from '@/components/elements/modals/LandingOrderModal.vue';
import LandingContactAuthorModal from '@/components/elements/modals/LandingContactAuthorModal.vue';
import { createClickAnchor } from '@/common/misc';

type CarouselSlide = {
    description: string, 
    authorName: string, 
    authorProfession: string,
    fitsOnMobile: boolean,
};

export default Vue.extend({
    name: 'landingView',
    mixins: [ResponsiveDataMixin],
    components: { LandingOrderBulkModal, LandingOrderModal, LandingContactAuthorModal },
    data(){
        return {
            showNavigationMenu: false,
            feedbackCarouselSlideIndex: 0,
            expandFeedbackCarouselText: false,
            switchingFeedbackCarouselSlides: false,
            switchingFeedbackCarouselPromises: [] as Promise<void>[],
        }
    },
    created(){
        window.addEventListener('keyup', this.onKeyPress);
    },
    destroyed(){
        window.removeEventListener('keyup', this.onKeyPress);
    },
    watch: {
        feedbackCarouselSlideIndex(slideIndex:number):void{
            this.expandFeedbackCarouselText = false;
            //$forceUpdate is called for displayExpandFeedbackDescription to be updated
            this.$forceUpdate();
        }
    },
    methods: {
        downloadBookDemo():void{
            createClickAnchor('/landing/your_first_business_demo.pdf',(a)=>{
                a.target='_blank';
                a.download = 'Твой_первый_бизнес_демо.pdf';
            });
        },
        async feedbackCarouselGoLeft(){
            this.feedbackCarouselSlideIndex--;
            this.switchingFeedbackCarouselPromises.push(this.switchSlidePromise());
        },
        async feedbackCarouselGoRight(){
            this.feedbackCarouselSlideIndex++;
            this.switchingFeedbackCarouselPromises.push(this.switchSlidePromise());
        },
        async switchSlidePromise():Promise<void>{
            this.switchingFeedbackCarouselSlides = true;
            await new Promise((r)=>setTimeout(r, 1500));
            if(this.switchingFeedbackCarouselPromises.length < 2) this.switchingFeedbackCarouselSlides = false;
        },
        onKeyPress(e:KeyboardEvent):void{
            if(e.key == "Escape"){
                this.showNavigationMenu = false;
                this.$modal.hideAll();
            }
        },
        scrollTo(section:{el:HTMLElement, [x:string]:any}){
            // console.log(section.el.getBoundingClientRect().top)
            const {el} = section;
            // smoothScrollTo(window.pageYOffset + el.getBoundingClientRect().top, 300);
            const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
            if(isSmoothScrollSupported) {
                el.scrollIntoView({behavior: "smooth"});
            } else {
                el.scrollIntoView(true);
            }

            if((this as any).isMobileWidth) this.showNavigationMenu = false;
            // section.el.scrollIntoView();
        },
        navBtnClick(){
            this.showNavigationMenu = !this.showNavigationMenu;
        },
        hideNavigationMenu():void {
            this.showNavigationMenu = false;
        },
        orderBtnClick():void {
            //called when 'Order' header button is clicked
            this.$modal.show('landingOrderModal');
        },
        orderBulkBtnClick():void {
            //called when 'Order 10+ books' button is clicked

            // this.$modal.show('landingOrderBulkModal');
            this.$modal.show('landingOrderModal');
        },
        messageAuthorBtnClick():void {
            //called when 'Contact author' button is clicked

            this.$modal.show('landingContactAuthorModal');
        },
    },
    computed: {
        displayExpandFeedbackDescription():boolean {
            return !this.currentFeedbackCarouselSlide.fitsOnMobile && !this.expandFeedbackCarouselText;
        },
        currentFeedbackCarouselSlide():CarouselSlide{
            return this.feedbackCarouselSlides[this.feedbackCarouselSlideIndex];
        },
        feedbackCarouselSlideEl():HTMLElement|undefined{
            return this.$refs.feedbackSlide as HTMLElement|undefined;
        },
        feedbackCarouselSlideDescriptionEl: {
            get():HTMLElement[]|HTMLElement|undefined{
                return this.$refs.feedbackSlideDescription as HTMLElement|HTMLElement[]|undefined;
            },
            cache: false,
        },
        feedbackCarouselSlides():CarouselSlide[]{
            return [
                {
                    description: '«Здесь есть всё, чтобы из того, что есть, сделать больше. Как много бы я отдал, чтобы иметь такую книгу в 12 лет!»',
                    authorName: 'Игорь Рыбаков',
                    authorProfession: 'Selfmade предприниматель и долларовый миллиардер',
                    fitsOnMobile: true,
                },
                {
                    description: '«Предпринимательство - это отношение к жизни, когда ты сам принимаешь решения и отвечаешь за них. Запуск своего проекта - это опыт, который можно прожить ещё в школе. Создать что-то ценное, не бояться ошибок, работать в команде, доводить дело до конца - это навыки, которые пригодятся каждому. Эта книга поможет тебе на пути к успеху»',
                    authorName: 'Аяз Шабутдинов',
                    authorProfession: 'предприниматель, основатель Like Центра',
                    fitsOnMobile: true,
                },
                {
                    description: '«Не каждый станет предпринимателем, но можно попробовать себя в этой роли ещё в школе и понять, насколько тебе это близко. Главное - действовать, а узнавать можно - по пути. И тут книга "Твой первый бизнес" станет для тебя хорошим попутчиком»',
                    authorName: 'Сергей Солонин',
                    authorProfession: 'предприниматель, инвестор, сооснователь компании Qiwi',
                    fitsOnMobile: true,
                },
                {
                    description: '«Книга Андрея Андрусова «Твой первый бизнес» предоставляет удивительную возможность каждому школьнику погрузиться в мир предпринимательства. Почему это важно? Потому что,  развитие  предпринимательского мышления является одним из ключевых навыков в современном мире. Книга А. Андрусова является уникальной, поскольку  включает в себя множество интереснейших  кейсов и переосмысленного личного опыта. Книга  написана простым и понятным языком, содержит конкретные инструменты, практические рекомендации  и алгоритмы для создания своего первого бизнес-проекта! Читая книгу, юные предприниматели под ментерством автора,  проходят  все этапы  создания бизнес-проекта. В частности, Ребята научаться генерировать бизнес-идеи, определять целевую аудиторию, формировать ценностное предложение, исследовать рынок, рассчитывать финансовую модель, разберутся с тем, что такое MVP. Книга Андрея Андрусова «Твой первый бизнес проект» учит ребят не боятся  ошибаться, действовать и самое главное вдохновляет на создание бизнес-проектов, которые будут способствовать изменению мира к лучшему!»',
                    authorName: 'Кнарик Арабян',
                    authorProfession: 'д.э.н., сооснователь детской бизнес-школы Kindermba',
                    fitsOnMobile: false,
                },
            ];
        },
        bookHelpsWithCards():{label:string}[]{
            return [
                {label: 'Найти подходящую нишу для бизнеса'},
                {label: 'Разработать продукт и запустить проект'},
                {label: 'Настроить маркетинг и продажи'},
                {label: 'Расчитать экономику и узнать, как привлечь финансирование'}
            ];
        },
        landingSections():{el: HTMLElement, label: string}[]{
            return [
                {label: 'О книге', ref: 'about-book'},
                {label: 'Книга поможет', ref: 'help-with'},
                {label: 'Об авторе', ref: 'about-author'},
                {label: 'Где купить?', ref: 'buy-online'},
                {label: 'Отзывы', ref: 'book-feedback'},
                {label: 'Бесплатная версия', ref: 'download-demo'},
            ].map((section)=>{
                return { el: (this.$refs[section.ref+'-section'] as HTMLElement), label: section.label }
            });
        },
    },
})
